export default "/img/PS.d0fd0f9535563662f277133d72c92e52.png";